import { render } from "./PreviewsPage.vue?vue&type=template&id=7bbf5d5e&scoped=true"
import script from "./PreviewsPage.vue?vue&type=script&lang=js"
export * from "./PreviewsPage.vue?vue&type=script&lang=js"

import "./PreviewsPage.vue?vue&type=style&index=0&id=7bbf5d5e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bbf5d5e"]])

export default __exports__